import LowFareCalendarOIV2ContainerMobile from '../../../../components/containers/LowFareCalendarOIV2ContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadLowFareCalendarProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'low-fare-calendar-outbound-inbound-v2--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: LowFareCalendarOIV2ContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
